import { UIService } from './../../ui.service';
import {
  Component,
  AfterContentInit,
  OnDestroy
} from '@angular/core';

import { ServiceLocator } from '../../ServiceLocator';
import { TranslateService } from '@ngx-translate/core';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { generateRandomIdentifier } from '../../ui.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../common/baseComponent/base.component';
import { collapseTextChangeRangesAcrossMultipleVersions } from 'typescript';
import { I18nData } from '../../api/plyca-dtos';

export class LongTextDTOModal {

  label: string;
  text: string;
  disabled = false;
  maxLong: number;


  constructor(
    label: string,
    text: string,
    disabled: boolean
  ) {
    this.label = label;
    this.text = text;
    this.disabled = disabled;
    this.maxLong = undefined;

  }
}


@Component({
  selector: 'longtext-editor',
  templateUrl: 'longTextEditor.template.html',
  providers: [DialogService]
})
export class LongTextEditorComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  public translate: TranslateService;
  public headerActionsService: HeaderActionsService;
  public waitService: WaitLoadingService;


  windowHash: string;
  loaded = false;
  label: string;
  labelDefault: string;
  text: string;
  context: LongTextDTOModal;
  disabled: boolean;
  maxLong: number;

  constructor(public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig, private uiService: UIService) {

    super();
    this.translate = ServiceLocator.injector.get(TranslateService);
    this.headerActionsService = ServiceLocator.injector.get(HeaderActionsService);
    this.waitService = ServiceLocator.injector.get(WaitLoadingService);


    this.context = dialogConfig['context'];
    this.label = this.context.label;
    this.text = this.context.text;
    this.disabled = this.context.disabled;
    this.maxLong = this.context?.maxLong;

    this.labelDefault = this.translate.instant('Forms.TextEditor.label');
    this.load();
  }

  load() {
    this.loaded = true;
  }

  ngAfterContentInit(): void {
    this.waitService.startWaiting();
    this.windowHash = generateRandomIdentifier();
    this.headerActionsService.clearWindowActions(this.windowHash);

    if (!this.disabled) {
      this.subscribe(this.headerActionsService.addWindowAction(
        'General.accept',
        'fas fa-check',
        'btn-primary',
        true, this.windowHash
      ), success => {

        if (this.maxLong != undefined && this.text.length > this.maxLong) {
          this.uiService.showMessage(
            this.translate.instant('Forms.error.maxlength',
              { actualLength: this.text.length, requiredLength: this.maxLong }),
            new I18nData('General.error')
          );
        } else {
          this.ref.close(this.text);
        }

      });

    }



    this.subscribe(this.headerActionsService.addWindowAction(
      'General.close',
      'fas fa-times',
      'btn-outline-secondary',
      true, this.windowHash
    ), success => {
      this.ref.close();
    });
    this.waitService.cancelWaiting();
  }


  ngOnDestroy() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.dialogConfig = null;
    this.ref = null;
    super.ngOnDestroy();
  }



  public isLoaded() { return this.loaded; }
}
